import { render, staticRenderFns } from "./TheSoundButton.vue?vue&type=template&id=ab545522&"
import script from "./TheSoundButton.vue?vue&type=script&lang=js&"
export * from "./TheSoundButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports